
  
import style from "./style.module.scss"
import { useTranslation } from "react-i18next";
export function Apdp({handleCheck,show=false}){ 
    const { t } = useTranslation("translations")

    const ftt = {
        width: '80%',
        marginTop: '5rem'
    }

    const textD = {
        fontWeight: 'bold',
        fontSize: '1rem',
        color: '#008080',
        marginTop: '0.5rem'
    }

    const link = {
        color: '#000',
        cursor: 'pointer',
        fontWeight: 'bold'
    }

    const closeIcon = {
        marginTop: '2rem',
        padding: '0.5rem 3rem',
        cursor: 'pointer',
        position: 'relative', 
        border: 'none',
        borderRadius: '0.5rem',
        fontFamily: "Typold Medium",
        transition: 'all 100ms',
        marginBottom: '1rem',
        background: '#008080',
        color: '#FFFFFF'
    }

    return  (!show?<></>:
    <div className={style.ftMobile}>
        <div style={ftt} className={style.fttMobl} id="ide">
            <div className={style.dg}>
                    
                    <div className={style.centre}>
                        <img src="/images/exclamation.png" className="" alt="Logo" width='80px' height='80px' /><br/><br/>
                        <span style={textD}>INFORMATION</span><br/>
                        
                    </div>
                    <>
                        {t('warning-msg.text1')}<br/><br/>
                        {t('warning-msg.text2')}<br/><br/>
                        {t('warning-msg.text3')}<br/><br/>
                        {t('warning-msg.text4')} <a href="/politique-confidentialite" rel="noreferrer" target='_blank' style={link}>{t('warning-msg.text4-link')}</a>.
                    </>

                    <div className={style["btn-confirm"]}><button onClick={handleCheck} style={closeIcon} className={style.closeIconMobile}>{t('warning-msg.btn')}</button></div>
            </div>
            
            
        </div>
    </div>)

}